import { axiosInstance } from "../core/http";

export const markupApi = {
  getStatus: (id) => axiosInstance.get(`/panel/markup/${id}/status/`),
  getCalibrationModels: () => null, //axiosInstance.get(`/panel/calibration/models/`),
  getCalibrationFrame: (id, model, time) =>
    axiosInstance.get(`/panel/markup/${id}/calibration/${model}/${time}`, {
      responseType: "arraybuffer",
    }),
  getFieldMeta: (videoId) =>
    axiosInstance.get(`/panel/match/${videoId}/field/`),
  updateFieldMeta: (videoId, data) =>
    axiosInstance.post(`/panel/match/${videoId}/field/update/`, data),
  updateDescriptors: (videoId, data) =>
    axiosInstance.post(`/panel/markup/${videoId}/descriptors/`, data),
  addEvent: (matchId, super_track_uid, data) =>
    axiosInstance.post(
      `/panel/state/event/${matchId}/${super_track_uid}/create/`,
      data
    ),
  updateEvent: (eventId, data) =>
    axiosInstance.put(`/panel/state/event/${eventId}/update/`, data),
  deleteEvent: (eventId) =>
    axiosInstance.delete(`/panel/state/event/${eventId}/remove/`),
  // Exercises API
  getExercisesList: (videoId) =>
    axiosInstance.get(`/panel/training_part/${videoId}/training_parts/`),
  createExercise: (videoId, data) =>
    axiosInstance.post(`/panel/training_part/${videoId}/create/`, data),
  updateExercise: (videoId, exerciseId, data) =>
    axiosInstance.put(`/panel/training_part/${videoId}/parts/${exerciseId}/update/`, data),
  deleteExercise: (videoId, exerciseId) =>
    axiosInstance.delete(`/panel/training_part/${videoId}/parts/${exerciseId}/update/`),
};
